<div class="container-fluid">

  <div class="pageheader d-flex align-items-center justify-content-between mb-2">
    <h4 class="d-flex align-items-center mb-1">Lenders</h4>
  </div>

  <app-card>
    <div class="d-flex justify-content-end mb-2">
      <button type="button" class="btn btn-success btn-sm" (click)="addLender()">
        <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
        Add Lender
      </button>
    </div>

    <app-table
      [columns]="columns"
      [data]="lenders"
      [totalCount]="resultsLength"
      [pageSize]="20"
      [loading]="isLoadingResults"
      [clickableRows]="true"
      [initialFilterValues]="{ isActive: '{{bool}}true' }"
      (searchChange)="onSearch($event)"
      (rowClick)="editLender($event)">

      <ng-template tableCell="isActive" let-row>
        <span class="badge" [ngClass]="row.isActive ? 'bg-success' : 'bg-danger'">
          {{ row.isActive ? 'Yes' : 'No' }}
        </span>
      </ng-template>

    </app-table>
  </app-card>
</div>